import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Circle from '@/components/UI/svg/SaveElectric/Circle';
import Plus from '@/components/UI/svg/SaveElectric/Plus';
import Minus from '@/components/UI/svg/SaveElectric/Minus';
import Link from '@/components/UI/svg/SaveElectric/Link';

export default function E() {
    const { useLang, gtm } = useGlobal();
    const { t } = useLang('save_electric');
    const [activeTab, setActiveTab] = useState(0);

    const gotoPage = (link: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'select_news',
            title_name: t('sec_6_title'),
            button_name: t('sec_6_btn'),
        });
        window.open(link);
    };

    return (
        <div className={`save-electric-e ${css.SaveElectricE}`}>
            <section className="section-a">
                <div className="text-wrapper">
                    <h2 className="title">{t('sec_6_title')}</h2>
                    <div
                        className={`tab ${activeTab === 1 ? 'active' : ''}`}
                        onClick={() => {
                            setActiveTab(activeTab === 1 ? 0 : 1);
                            const dom = document.querySelector('.save-electric-e')?.offsetTop || 3638;
                            window.scrollTo({
                                top: dom + 214,
                                behavior: 'smooth',
                            });
                        }}
                    >
                        <div className="icon-1">
                            {activeTab === 1 ? <Minus width="0.27rem" height="0.27rem" /> : <Plus width="0.27rem" height="0.27rem" stroke="#fff" />}
                        </div>
                        <p className="tab-text">{t('sec_6_tab1')}</p>

                        <div className="tab-content content-1">
                            <div className="solution">
                                <Circle num={1} width="0.6rem" height="0.4rem" />
                                <p className="text-white text">{t('sec_6_tab1_text1')}</p>
                            </div>
                            <div className="solution">
                                <Circle num={2} width="0.6rem" height="0.4rem" />
                                <p className="text-white text">{t('sec_6_tab1_text2')}</p>
                            </div>
                            <div className="solution">
                                <Circle num={3} width="0.6rem" height="0.4rem" />
                                <p className="text-white text">{t('sec_6_tab1_text3')}</p>
                            </div>
                            <div className="link_btn" onClick={() => gotoPage('https://blog.ecoflow.com/jp/be-patient/')}>
                                {t('sec_6_btn')}
                                <div className="icon icon-white">
                                    <Link width="0.14rem" height="0.14rem" />
                                </div>
                                <div className="icon icon-blue">
                                    <Link stroke="#3f68e0" width="0.14rem" height="0.14rem" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className={`tab ${activeTab === 2 ? 'active' : ''}`}
                        onClick={() => {
                            setActiveTab(activeTab === 2 ? 0 : 2);
                            const dom = document.querySelector('.save-electric-e')?.offsetTop || 3638;
                            window.scrollTo({
                                top: dom + 286,
                                behavior: 'smooth',
                            });
                        }}
                    >
                        <div className="icon-1">
                            {activeTab === 2 ? <Minus width="0.27rem" height="0.27rem" /> : <Plus width="0.27rem" height="0.27rem" stroke="#fff" />}
                        </div>
                        <p className="tab-text">{t('sec_6_tab2')}</p>
                        <div className="tab-content">
                            <p className="text text-white content-2-text">{t('sec_6_tab2_desc')}</p>
                            <div className="solution content-2">
                                <Circle num={1} width="0.6rem" height="0.4rem" />
                                <div className="text">
                                    {t.rich('sec_6_tab2_text1', {
                                        title: (text: string) => <p className="text-white">{text}</p>,
                                    })}
                                </div>
                            </div>
                            <div className="solution content-2">
                                <Circle num={2} width="0.6rem" height="0.4rem" />
                                <div className="text">
                                    {t.rich('sec_6_tab2_text2', {
                                        title: (text: string) => <p className="text-white">{text}</p>,
                                    })}
                                </div>
                            </div>
                            <div className="solution content-2">
                                <Circle num={3} width="0.6rem" height="0.4rem" />
                                <div className="text">
                                    {t.rich('sec_6_tab2_text3', {
                                        title: (text: string) => <p className="text-white">{text}</p>,
                                    })}
                                </div>
                            </div>
                            <div className="solution content-2">
                                <Circle num={4} width="0.6rem" height="0.4rem" />
                                <div className="text">
                                    {t.rich('sec_6_tab2_text4', {
                                        title: (text: string) => <p className="text-white">{text}</p>,
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-b">
                <h2 className="title">{t('sec_7_title')}</h2>
                <div className="desc">
                    {t.rich('sec_7_desc', {
                        p: (text: string) => <p className="p">{text}</p>,
                        bold: (text: string) => <p className="bold">{text}</p>,
                    })}
                </div>
            </section>
        </div>
    );
}
